// src/pages/user/ProfilePage.js
import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { 
  User, 
  Mail, 
  Phone, 
  Edit3, 
  Save, 
  X, 
  Trash2, 
  Heart, 
  Settings,
  ArrowRight,
  AlertTriangle,
  Calendar
} from 'lucide-react';

const ProfilePage = () => {
  const { user, userProfile, updateUserProfile, deleteUserAccount, logout, getFavorites } = useAuth();
  const navigate = useNavigate();
  
  const [activeTab, setActiveTab] = useState('profile');
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [editData, setEditData] = useState({
    firstName: userProfile?.firstName || '',
    lastName: userProfile?.lastName || '',
    phone: userProfile?.phone || ''
  });

  const favorites = getFavorites();
useEffect(() => { console.log(userProfile); }, [userProfile]); 

  const handleSaveProfile = async () => {
    setLoading(true);
    const result = await updateUserProfile(editData);
    
    if (result.success) {
      setIsEditing(false);
    }
    setLoading(false);
  };

  const handleDeleteAccount = async () => {
    setLoading(true);
    const result = await deleteUserAccount();
    
    if (result.success) {
      navigate('/');
    } else {
      alert(result.error);
    }
    setLoading(false);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const openProductDetails = (favorite) => {
    navigate(`/product/${favorite.category}/${favorite.id}`);
  };

const formatDate = (dateString) => {
  if (!dateString) return 'לא זמין';
  return new Date(dateString).toLocaleDateString('he-IL');
};

  const tabs = [
    { id: 'profile', label: 'פרופיל', icon: User },
    { id: 'favorites', label: 'מועדפים', icon: Heart },
    { id: 'settings', label: 'הגדרות', icon: Settings }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* כותרת וניווט */}
        <div className="mb-8">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-4 group"
          >
            <ArrowRight className="w-4 h-4 mr-1 group-hover:-translate-x-1 transition-transform" />
            <span className="text-sm font-medium">חזרה לדף הבית</span>
          </button>
          
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-2xl flex items-center justify-center">
              <User className="w-8 h-8 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                {userProfile?.displayName || 'משתמש'}
              </h1>
              <p className="text-gray-600">{user?.email}</p>
            </div>
          </div>
        </div>

        {/* טאבים */}
        <div className="mb-8">
          <div className="border-b border-gray-200">
            <nav className="flex space-x-8 space-x-reverse">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`
                      flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm
                      ${activeTab === tab.id
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }
                    `}
                  >
                    <Icon className="w-4 h-4" />
                    {tab.label}
                    {tab.id === 'favorites' && favorites.length > 0 && (
                      <span className="bg-blue-100 text-blue-600 text-xs rounded-full px-2 py-1">
                        {favorites.length}
                      </span>
                    )}
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* תוכן הטאבים */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
          
          {/* טאב פרופיל */}
          {activeTab === 'profile' && (
            <div className="p-8">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-gray-900">פרטים אישיים</h2>
                {!isEditing && (
                  <button
                    onClick={() => setIsEditing(true)}
                    className="flex items-center gap-2 px-4 py-2 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-lg transition-colors"
                  >
                    <Edit3 className="w-4 h-4" />
                    עריכה
                  </button>
                )}
              </div>

              {isEditing ? (
                <form className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        שם פרטי
                      </label>
                      <input
                        type="text"
                        value={editData.firstName}
                        onChange={(e) => setEditData(prev => ({ ...prev, firstName: e.target.value }))}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        שם משפחה
                      </label>
                      <input
                        type="text"
                        value={editData.lastName}
                        onChange={(e) => setEditData(prev => ({ ...prev, lastName: e.target.value }))}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      טלפון
                    </label>
                    <input
                      type="tel"
                      value={editData.phone}
                      onChange={(e) => setEditData(prev => ({ ...prev, phone: e.target.value }))}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                      dir="ltr"
                    />
                  </div>

                  <div className="flex gap-4">
                    <button
                      type="button"
                      onClick={handleSaveProfile}
                      disabled={loading}
                      className="flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50"
                    >
                      <Save className="w-4 h-4" />
                      {loading ? 'שומר...' : 'שמור'}
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setIsEditing(false);
                        setEditData({
                          firstName: userProfile?.firstName || '',
                          lastName: userProfile?.lastName || '',
                          phone: userProfile?.phone || ''
                        });
                      }}
                      className="flex items-center gap-2 px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg font-medium transition-colors"
                    >
                      <X className="w-4 h-4" />
                      ביטול
                    </button>
                  </div>
                </form>
              ) : (
                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg">
                      <User className="w-5 h-5 text-gray-500" />
                      <div>
                        <p className="text-sm text-gray-600">שם מלא</p>
                        <p className="font-medium text-gray-900">
                          {userProfile?.displayName || 'לא הוגדר'}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg">
                      <Mail className="w-5 h-5 text-gray-500" />
                      <div>
                        <p className="text-sm text-gray-600">אימייל</p>
                        <p className="font-medium text-gray-900" dir="ltr">
                          {user?.email}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg">
                    <Phone className="w-5 h-5 text-gray-500" />
                    <div>
                      <p className="text-sm text-gray-600">טלפון</p>
                      <p className="font-medium text-gray-900" dir="ltr">
                        {userProfile?.phone || 'לא הוגדר'}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg">
                    <Calendar className="w-5 h-5 text-gray-500" />
                    <div>
                <p className="text-sm text-gray-600">תאריך הצטרפות</p>
    <p className="font-medium text-gray-900">
      {formatDate(userProfile?.createdAt || userProfile?.updatedAt)}
    </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* טאב מועדפים */}
          {activeTab === 'favorites' && (
            <div className="p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-6">המועדפים שלי</h2>
              
              {favorites.length === 0 ? (
                <div className="text-center py-12">
                  <Heart className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                  <h3 className="text-lg font-medium text-gray-900 mb-2">אין מועדפים עדיין</h3>
                  <p className="text-gray-600 mb-6">
                    תוכל להוסיף מוצרים למועדפים על ידי לחיצה על אייקון הלב בדף המוצר
                  </p>
                  <button
                    onClick={() => navigate('/')}
                    className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors"
                  >
                    חפש מוצרים
                  </button>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {favorites.map((favorite) => (
                    <div
                      key={favorite.id}
                      className="border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow cursor-pointer group"
                      onClick={() => openProductDetails(favorite)}
                    >
                      <div className="flex justify-between items-start mb-4">
                        <div className="flex-1">
                          <h3 className="font-bold text-lg text-gray-900 mb-1 group-hover:text-blue-600 transition-colors">
                            {favorite.name}
                          </h3>
                          <p className="text-sm text-gray-600">{favorite.company}</p>
                        </div>
                        <Heart className="w-5 h-5 text-red-500 fill-current" />
                      </div>

                      <div className="flex items-center gap-2 mb-4">
                        <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
                          {favorite.category}
                        </span>
                        <span className="text-xs text-gray-500">
                          נוסף ב-{formatDate(favorite.addedAt)}
                        </span>
                      </div>

                      <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600">לחץ לצפייה</span>
                        <ArrowRight className="w-4 h-4 text-gray-400 group-hover:text-blue-600 transition-colors" />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* טאב הגדרות */}
          {activeTab === 'settings' && (
            <div className="p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-6">הגדרות חשבון</h2>
              
              <div className="space-y-6">
                
                {/* התנתקות */}
                <div className="border border-gray-200 rounded-lg p-6">
                  <h3 className="text-lg font-medium text-gray-900 mb-2">התנתקות</h3>
                  <p className="text-gray-600 mb-4">
                    התנתק מהחשבון שלך במכשיר הנוכחי
                  </p>
                  <button
                    onClick={handleLogout}
                    className="px-6 py-3 bg-gray-600 hover:bg-gray-700 text-white rounded-lg font-medium transition-colors"
                  >
                    התנתק
                  </button>
                </div>

                {/* מחיקת חשבון */}
                <div className="border border-red-200 rounded-lg p-6 bg-red-50">
                  <h3 className="text-lg font-medium text-red-900 mb-2">מחיקת חשבון</h3>
                  <p className="text-red-700 mb-4">
                    פעולה זו תמחק את החשבון שלך לצמיתות ולא תהיה ניתנת לביטול. 
                    כל המועדפים והנתונים שלך יימחקו.
                  </p>
                  
                  {!showDeleteConfirm ? (
                    <button
                      onClick={() => setShowDeleteConfirm(true)}
                      className="flex items-center gap-2 px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors"
                    >
                      <Trash2 className="w-4 h-4" />
                      מחק חשבון
                    </button>
                  ) : (
                    <div className="space-y-4">
                      <div className="flex items-center gap-3 p-4 bg-red-100 border border-red-300 rounded-lg">
                        <AlertTriangle className="w-5 h-5 text-red-600" />
                        <span className="text-red-800 font-medium">
                          האם אתה בטוח? פעולה זו לא ניתנת לביטול!
                        </span>
                      </div>
                      <div className="flex gap-4">
                        <button
                          onClick={handleDeleteAccount}
                          disabled={loading}
                          className="flex items-center gap-2 px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50"
                        >
                          <Trash2 className="w-4 h-4" />
                          {loading ? 'מוחק...' : 'כן, מחק את החשבון'}
                        </button>
                        <button
                          onClick={() => setShowDeleteConfirm(false)}
                          className="px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg font-medium transition-colors"
                        >
                          ביטול
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;